<template>
  <div>
    <van-tabs v-model:active="activeKey">
      <van-tab title="流程执行">
        <ProcessRun></ProcessRun>
      </van-tab>
      <van-tab title="执行记录">
        <ProcessJob></ProcessJob>
      </van-tab>
      <van-tab title="排队情况">
        <QueueList></QueueList>
      </van-tab>
      <van-tab title="资产列表">
        <ProcessAsset></ProcessAsset>
      </van-tab>

    </van-tabs>
  </div>

</template>

<script>
import {defineComponent, ref} from 'vue';
import ProcessAsset from "@/pages/mobile/dashboard/ProcessAsset";
import ProcessRun from "@/pages/mobile/dashboard/ProcessRun";
import ProcessJob from "@/pages/mobile/dashboard/ProcessJob";
import QueueList from "@/pages/mobile/dashboard/QueueList"
import {Tab, Tabs} from 'vant'
import 'vant/lib/index.css'

export default defineComponent({
  name: "mobilemain",
  components: {
    ProcessAsset, ProcessJob, ProcessRun, QueueList, [Tab.name]: Tab, [Tabs.name]: Tabs
  },
  setup() {
    const activeKey = ref(0)
    return {
      activeKey
    }
  }
})
</script>

<style scoped>

</style>
